import { GetAccountRepresentativesRoutine } from '../redux-routines';

export const initialState = {
  isFetching: false,
  data: [],
  error: null
};

export const accountRepresentativesListReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case GetAccountRepresentativesRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null
      };
    case GetAccountRepresentativesRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case GetAccountRepresentativesRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    default:
      return state;
  }
};
